import React from 'react';

import { type EmptyStateProps } from '@atlaskit/empty-state';
import Spinner from '@atlaskit/spinner';

import { ErrorState } from './error-state';
import { CenteredWrapper, CurrentContentWrapper } from './styled';

interface OwnProps {
	testId: string;
	isFetchLoading: boolean | undefined;
	hasError: boolean | undefined;
	isSubmissionLoading: boolean | undefined;
	content: React.ReactNode;
	errorContent:
		| Pick<EmptyStateProps, 'header' | 'description' | 'primaryAction' | 'imageUrl'>
		| undefined;
}

export const Content = ({
	isFetchLoading,
	hasError,
	isSubmissionLoading,
	content,
	errorContent,
	testId,
}: OwnProps) => {
	if (isFetchLoading) {
		return (
			<CenteredWrapper>
				<Spinner size="xlarge" testId={`${testId}-fetch-spinner`} />
			</CenteredWrapper>
		);
	}

	if (hasError && !isSubmissionLoading) {
		return <ErrorState errorContent={errorContent} testId={testId} />;
	}

	return (
		<CurrentContentWrapper data-testid={`${testId}-blanket`} submitting={!!isSubmissionLoading}>
			{content}
		</CurrentContentWrapper>
	);
};
